<ng-container [ngSwitch]="inline">
  <ng-container *ngSwitchCase="true">
    <div [ngClass]="colClass">
      <label class="form-label" *ngIf="!hideLabel">{{ label }}</label>
      <select class="form-select formMainSelectdiv"
              [(ngModel)]="mode"
              (change)="onModeChange(mode)">
        <option *ngFor="let o of visibleOptions" [value]="o.value">{{ o.label }}</option>
      </select>
    </div>

    <div [ngClass]="colClass" *ngIf="mode === 'specificMonth'">
      <label class="form-label" *ngIf="!hideLabel">Select Month</label>
      <input type="month" class="form-control"
             [(ngModel)]="selectedMonth"
             (change)="onMonthPicked()" />
    </div>

    <div [ngClass]="colClass" *ngIf="mode === 'custom'">
      <label class="form-label" *ngIf="!hideLabel">From Date</label>
      <input type="date" class="form-control dateFormat"
             [(ngModel)]="fromDate"
             (ngModelChange)="onCustomDateChange()" />
    </div>

    <div [ngClass]="colClass" *ngIf="mode === 'custom'">
      <label class="form-label" *ngIf="!hideLabel">To Date</label>
      <input type="date" class="form-control dateFormat"
             [(ngModel)]="toDate"
             (ngModelChange)="onCustomDateChange()" />
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="date-filter-block">
      <label class="form-label">{{ label }}</label>
      <div class="date-filter-row">
        <select class="form-select formMainSelectdiv"
                [(ngModel)]="mode"
                (change)="onModeChange(mode)">
          <option *ngFor="let o of visibleOptions" [value]="o.value">{{ o.label }}</option>
        </select>

        <input *ngIf="mode === 'specificMonth'" type="month" class="form-control"
               [(ngModel)]="selectedMonth"
               (change)="onMonthPicked()" />

        <ng-container *ngIf="mode === 'custom'">
          <input type="date" class="form-control dateFormat"
                 [(ngModel)]="fromDate"
                 (ngModelChange)="onCustomDateChange()" />
          <input type="date" class="form-control dateFormat"
                 [(ngModel)]="toDate"
                 (ngModelChange)="onCustomDateChange()" />
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
